import { ref } from "vue";

const { Drupal, drupalSettings, location } = window;
const hasDrupalSettings =
  typeof drupalSettings !== "undefined" &&
  drupalSettings.hasOwnProperty("user");
const isB4 = location.href.includes("-b4.") || hasDrupalSettings;
const isB3 = !isB4 && typeof Drupal !== "undefined";
let devServerRunning = false;
try {
  devServerRunning = WEBPACK_DEV_SERVER === "true";
} catch (e) {
  // eslint-disable-next-line
  console.warn(e);
}
const browseThruDevServer =
  devServerRunning && window.location.hostname.includes("localhost");
let isCypress = false;
try {
  isCypress = CYPRESS === "true";
} catch (e) {
  // eslint-disable-next-line
  console.warn(e);
}
const manualTitle = ref(null);

const showBeta = ref(false);

let isProduction;
try {
  isProduction = NODE_ENV === "production";
} catch (e) {
  isProduction = false;
}

// eslint-disable-next-line import/prefer-default-export
export function useEnvVars() {
  function toggleShowBeta() {
    showBeta.value = !showBeta.value;
  }

  function setManualTitle(value) {
    manualTitle.value = value;
  }

  return {
    isB4,
    isB3,
    devServerRunning,
    browseThruDevServer,
    isCypress,
    Drupal,
    drupalSettings,
    hasDrupalSettings,
    showBeta,
    toggleShowBeta,
    manualTitle,
    setManualTitle,
    isProduction,
  };
}
